import {
  AppBar,
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer, useRef } from 'react';

import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import Revulation from './Revulation.js';
import Retest from './Retest';
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  header12: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '30px',
  },
  header1: {
    background: 'transparent',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  TitleBox: {
    display: 'flex',
    float: 'left',
    margin: '25px 10px',
    padding: '10px',
    background: '#fff',
  },
  TitleTextSpan: {
    fontSize: '16px',
    fontWeight: 'bolder',
    marginLeft: '10px',
  },
  TitleText: {
    fontSize: '10px',
    paddingLeft: '10px',
  },
}));

const RevaluationRetest = () => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Box>
      <div style={{ marginTop: '50px' }}>
        <AppBar position="static" elevation={0} className={classes.header}>
          <Revulation />
        </AppBar>
      </div>
      <AppBar position="static" elevation={0} className={classes.header12}>
        <Retest />
      </AppBar>
    </Box>
  );
};

export default RevaluationRetest;
